<template>
  <header class="blog-header">
    <div class="header-inner">
      <router-link to="/" class="site-logo">
        <span class="logo-dot"></span>
        Wbxsb Blog
      </router-link>
      <nav class="header-nav">
        <router-link to="/" exact-active-class="nav-active">首页</router-link>
        <router-link to="/tags" active-class="nav-active">标签</router-link>
        <router-link to="/projects" active-class="nav-active">项目</router-link>
        <router-link to="/tools" active-class="nav-active">工具</router-link>
        <button class="theme-toggle" @click="toggleTheme" :title="isDark ? '切换到浅色' : '切换到深色'">
          <i :class="isDark ? 'el-icon-sunny' : 'el-icon-moon'"></i>
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'BlogHeader',
  computed: {
    isDark() {
      return this.$store.getters.isDark
    }
  },
  methods: {
    toggleTheme() {
      this.$store.dispatch('toggleTheme')
    }
  }
}
</script>

<style scoped>
.blog-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: color-mix(in srgb, var(--blog-bg) 85%, transparent);
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  border-bottom: 1px solid var(--blog-border-light);
  transition: background 0.3s, border-color 0.3s;
}
.header-inner {
  max-width: 72rem;
  margin: 0 auto;
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
}
.site-logo {
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--blog-text) !important;
  text-decoration: none !important;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  letter-spacing: -0.02em;
}
.logo-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: var(--blog-accent);
  border-radius: 50%;
}
.header-nav {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.header-nav a {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--blog-text-2) !important;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  text-decoration: none !important;
  transition: all 0.15s;
}
.header-nav a:hover { color: var(--blog-text) !important; background: var(--blog-bg-tertiary); }
.nav-active { color: var(--blog-text) !important; background: var(--blog-bg-tertiary); }

.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--blog-border);
  border-radius: 0.5rem;
  background: var(--blog-bg-elevated);
  cursor: pointer;
  color: var(--blog-text-2);
  font-size: 1rem;
  transition: all 0.15s;
  padding: 0;
  margin-left: 0.5rem;
}
.theme-toggle:hover {
  border-color: var(--blog-accent);
  color: var(--blog-accent);
  background: var(--blog-accent-subtle);
}

@media (max-width: 768px) {
  .header-inner { padding: 0 1rem; }
  .header-nav { gap: 0; }
  .header-nav a { padding: 0.4rem 0.5rem; font-size: 0.8rem; }
}
</style>
